import { render, staticRenderFns } from "./catalog-manager.vue?vue&type=template&id=744a36b0&scoped=true"
import script from "./catalog-manager.vue?vue&type=script&lang=js"
export * from "./catalog-manager.vue?vue&type=script&lang=js"
import style0 from "./catalog-manager.vue?vue&type=style&index=0&id=744a36b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a36b0",
  null
  
)

export default component.exports